import React, { memo, useCallback } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import GenerateArea from 'Pods/ThreeDStudio/Shared/GenerateArea/GenerateArea'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsModelSettingsOpen } from 'Pods/ThreeDStudio/Store/actions/ui'

import CollapsedModelSettings from './Components/CollapsedModelSettings/CollapsedModelSettings'
import ModelSettings from './Components/ModelSettings/ModelSettings'

function LeftSide() {
  const isModelSettingsOpen = useThreeDStudioStore(state => state.ui?.isModelSettingsOpen)
  const isModelUploading = useThreeDStudioStore(state => state.ui?.isModelUploading)
  const isImageUploading = useThreeDStudioStore(state => state.ui?.isImageUploading)
  // Origin rides on the navigation: the gallery opens a model with
  // `state: { fromGallery: true }`, so only gallery-opened models read as a remix.
  // Any other entry point (library card, deep link, refresh) keeps the plain label.
  const fromGallery = useLocation()?.state?.fromGallery === true

  const handleClick = useCallback(() => {
    setIsModelSettingsOpen(true)
  }, [])

  return (
    <div className={classnames(
      'main-panel__left-side',
      isModelSettingsOpen && 'main-panel__left-side--opened'
    )}>
      <div className={
        classnames(
          'main-panel__left-side-content',
          isModelSettingsOpen && 'main-panel__left-side-content--opened'
        )}
        onClick={!isModelSettingsOpen ? handleClick : undefined}
      >
        {isModelSettingsOpen ? (
          <div className="main-panel__left-side-content-inner">
            <ModelSettings />
            <GenerateArea
              generateLabel={fromGallery ? 'Regenerate 3D Model' : 'Generate 3D Model'}
              generatedLabel="Generated"
              generatingLabel="Generating..."
              withPrivateModeSelector
              isGenerateDisabled={isModelUploading || isImageUploading}
            />
          </div>
        ) : (
          <CollapsedModelSettings />
        )}
      </div>
    </div>
  )
}

export default memo(LeftSide)
